<template>
  <div class="workbench-box">
    <div class="center-box">
      <div class="workbench-content">
        <div class="workbench-left">
          <template v-for="(item, index) in navList">
            <div
              :class="[
                'workbench-nav_item',
                activeNav === item.id ? 'active' : '',
              ]"
              @click="clickNavItem(item)"
              :key="index"
            >
              {{ item.name }}
            </div>
          </template>
        </div>
        <div class="workbench-right">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "WorkbenchLayout",
  data() {
    return {
      activeNav: "",
      /**
       * name：nav显示的名称
       * id：与router.js中meta.nav字段对应
       * routeName：跳转的router的name
       */
      navList: [
        {
          name: "工作台",
          id: "workbench",
          routeName: "WorkbenchHome",
        },
        {
          name: "个人信息修改",
          id: "change-info",
          routeName: "WorkbenchChangeInfo",
        },
        {
          name: "原系统账号解绑",
          id: "unbund",
          routeName: "WorkbenchUnbund",
        },
        {
          name: "修改密码",
          id: "change-pwd",
          routeName: "WorkbenchChangePassword",
        },
      ],
    };
  },
  watch: {
    $route(val) {
      const { meta } = val;
      this.activeNav = meta.nav;
    },
  },
  mounted() {
    const { meta } = this.$route;
    this.activeNav = meta.nav;
  },
  methods: {
    clickNavItem(navItem) {
      const { activeNav } = this;
      const { routeName, id } = navItem;
      if (id === activeNav) {
        return;
      }
      this.$router.push({
        name: routeName,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
